import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  ordersGridWrapper: {
    padding: "16px 32px",
  },
  actionIcon: {
    cursor: "pointer",
    marginLeft: "3px",
  },
  titleContainer: {
    backgroundColor: getBrandCustom("subHeaderBackgroundColor", "#F8F9FC"),
    height: "64px",
    boxShadow: "inset 0px -1px 0px #F0F0F0",
    marginBottom: "24px",
    marginTop: "-15px",
    marginLeft: "-32px",
    width: "calc(100% + 64px)",
    padding: "0px 32px",
  },
  title: {
    fontFamile: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "24px",
    color: getBrandCustom("primaryColor", "#38CFC4"),
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "15px",
  },
  button: {
    cursor: "pointer",
  },
}));

export default styles;
